import { render, staticRenderFns } from "./TaskAssigner.vue?vue&type=template&id=4afef73c&"
import script from "./TaskAssigner.vue?vue&type=script&lang=js&"
export * from "./TaskAssigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports